import { takeLatest } from 'redux-saga/effects';
import { CHANGE_CLIENT_STATUS_SUCCES, DELETE_CLIENT_AVATAR_SUCCESS } from 'redux/actions/clients';
import { onChangeClientStatus } from './onChangeClientStatus';
import { onDeleteClientAvatar } from './onDeleteClientAvatar';

export default function* fn() {
  yield takeLatest(CHANGE_CLIENT_STATUS_SUCCES.type, onChangeClientStatus);
  yield takeLatest(DELETE_CLIENT_AVATAR_SUCCESS.type, onDeleteClientAvatar);
}
